/* eslint-disable global-require */
module.exports = ['lots.search.filters.inputs.auctioneer.m1', 'components.search.inputs.auctioneer_search.m3'];
